import {
  extendLocaleRecord,
  type LegacyLocale,
} from "../translations";

export type QuoteListCopy = {
  title: string;
  shortTitle: string;
  add: string;
  added: string;
  remove: string;
  clear: string;
  review: string;
  addCompared: string;
  empty: string;
  limit: string;
  productPicker: string;
  count: string;
};

const legacyQuoteListCopy = {
  en: {
    title: "Product quote list", shortTitle: "Quote list", add: "Add to quote list",
    added: "In quote list", remove: "Remove", clear: "Clear list", review: "Review quote request",
    addCompared: "Add compared products to quote list", empty: "No products have been added yet.",
    limit: "You can add up to eight products.", productPicker: "Add another product",
    count: "{count} products selected",
  },
  tr: {
    title: "Ürün teklif listesi", shortTitle: "Teklif listesi", add: "Teklif listesine ekle",
    added: "Teklif listesinde", remove: "Kaldır", clear: "Listeyi temizle", review: "Teklif talebini incele",
    addCompared: "Karşılaştırılan ürünleri teklif listesine ekle", empty: "Henüz ürün eklenmedi.",
    limit: "En fazla sekiz ürün ekleyebilirsiniz.", productPicker: "Başka ürün ekle",
    count: "{count} ürün seçildi",
  },
  ru: {
    title: "Список продукции для запроса", shortTitle: "Список запроса", add: "Добавить в запрос",
    added: "В списке запроса", remove: "Удалить", clear: "Очистить список", review: "Проверить запрос",
    addCompared: "Добавить сравниваемые позиции в запрос", empty: "Продукция пока не добавлена.",
    limit: "Можно добавить до восьми позиций.", productPicker: "Добавить ещё продукцию",
    count: "Выбрано позиций: {count}",
  },
  kk: {
    title: "Өнімдерге баға сұрау тізімі", shortTitle: "Баға сұрау тізімі", add: "Тізімге қосу",
    added: "Тізімге қосылған", remove: "Жою", clear: "Тізімді тазалау", review: "Сұрауды тексеру",
    addCompared: "Салыстырылған өнімдерді тізімге қосу", empty: "Әзірге өнім қосылмаған.",
    limit: "Сегіз өнімге дейін қосуға болады.", productPicker: "Тағы өнім қосу",
    count: "{count} өнім таңдалды",
  },
  ky: {
    title: "Өнүмдөр боюнча сунуш тизмеси", shortTitle: "Сунуш тизмеси", add: "Тизмеге кошуу",
    added: "Тизмеде", remove: "Алып салуу", clear: "Тизмени тазалоо", review: "Сунушту карап чыгуу",
    addCompared: "Салыштырылган өнүмдөрдү тизмеге кошуу", empty: "Азырынча өнүм кошулган жок.",
    limit: "Сегизге чейин өнүм кошо аласыз.", productPicker: "Дагы өнүм кошуу",
    count: "{count} өнүм тандалды",
  },
  uz: {
    title: "Mahsulotlar bo‘yicha taklif ro‘yxati", shortTitle: "Taklif ro‘yxati", add: "Ro‘yxatga qo‘shish",
    added: "Ro‘yxatda", remove: "Olib tashlash", clear: "Ro‘yxatni tozalash", review: "So‘rovni ko‘rib chiqish",
    addCompared: "Solishtirilgan mahsulotlarni ro‘yxatga qo‘shish", empty: "Hali mahsulot qo‘shilmagan.",
    limit: "Sakkiztagacha mahsulot qo‘shish mumkin.", productPicker: "Yana mahsulot qo‘shish",
    count: "{count} ta mahsulot tanlandi",
  },
  tg: {
    title: "Рӯйхати маҳсулот барои пешниҳод", shortTitle: "Рӯйхати пешниҳод", add: "Ба рӯйхат илова кунед",
    added: "Дар рӯйхат", remove: "Хориҷ кунед", clear: "Рӯйхатро тоза кунед", review: "Дархостро баррасӣ кунед",
    addCompared: "Маҳсулоти муқоисашударо ба рӯйхат илова кунед", empty: "Ҳоло маҳсулот илова нашудааст.",
    limit: "То ҳашт маҳсулот илова кардан мумкин аст.", productPicker: "Маҳсулоти дигар илова кунед",
    count: "{count} маҳсулот интихоб шуд",
  },
  tk: {
    title: "Önüm teklip sanawy", shortTitle: "Teklip sanawy", add: "Sanawa goşuň",
    added: "Sanawda", remove: "Aýyryň", clear: "Sanawy arassalaň", review: "Talaby gözden geçiriň",
    addCompared: "Deňeşdirilen önümleri sanawa goşuň", empty: "Entäk önüm goşulmady.",
    limit: "Sekize çenli önüm goşup bilersiňiz.", productPicker: "Başga önüm goşuň",
    count: "{count} önüm saýlandy",
  },
} satisfies Record<LegacyLocale, QuoteListCopy>;

export const quoteListCopy =
  extendLocaleRecord<QuoteListCopy>(
    legacyQuoteListCopy,
  );
